/* todo 存localStorage */
import CryptoJS from "crypto-js";
import JSEncrypt from "jsencrypt";

export const setStorage = (name, data) => {
    localStorage.setItem(name, JSON.stringify(data));
};

// AES 加密业务数据：AES-128-ECB
const encryptByAesKey = (data, aesKey) => {
    return CryptoJS.AES.encrypt(data, CryptoJS.enc.Utf8.parse(aesKey), {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    }).toString();
}
// 公钥加密
const encryptByPublicKey = (data, publicKey) => {
    const encryptor = new JSEncrypt();
    encryptor.setPublicKey(publicKey);
    return encryptor.encrypt(data);
}

/* 请求数据加密 */
export const getRequestArgsCrypto = (data) => {

    const serverPublicKey = '-----BEGIN PUBLIC KEY-----\n' +
        'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDEY/ZJ6OYpdM4cs7bHF2BzjKLC\n' +
        'T2i1Wrus0GY0d5nI1qGRHSRp2Cb1IrZbN2cju3tB4kMTUFcALgOB8eiak8CVgFlh\n' +
        'TgIoc+9hKE2fwgByUbto3kym35FCAJPVTjDl//Zfcysxv/KX75ka1sFcM2ZR5oGN\n' +
        '1K04Hwvo+TBr+GxpFQIDAQAB\n' +
        '-----END PUBLIC KEY-----';

    const aesKey = CryptoJS.MD5(Math.random().toString() + Date.now().toString()).toString().substring(0, 16);
    const secretKey = encryptByPublicKey(aesKey, serverPublicKey);
    const content = encryptByAesKey(data, aesKey);
    const timestamp = Math.floor(Date.now() / 1000);
    const nonce = CryptoJS.MD5(Math.random().toString() + Date.now().toString()).toString();
    const signStr = `content=${content}&nonce=${nonce}&timestamp=${timestamp}${aesKey}`;
    const sign = CryptoJS.MD5(signStr).toString();

    return {
        secretKey,
        content,
        nonce,
        timestamp,
        sign
    }
}

/* 获取localstorage中token */
export const getToken = () => {

    const tokenInfo = getTokenInfoStorage();

    //默认获取不到token为空string
    if (tokenInfo !== undefined && tokenInfo != null && tokenInfo !== "") {
        return tokenInfo
    }
}

// 取localStorage中记住密码信息
export const getRememberPassword = () => {
    return JSON.parse(localStorage.getItem('rememberPassword'))
};

// 清空token
export const getClearToken = () => {
    localStorage.setItem('tokenInfo',null)
    localStorage.setItem('refresh_token',null)
};

/* todo 取localStorage中信息 */
export const getStorage = (str) => {
    return JSON.parse(localStorage.getItem(str))
};

/* todo 取localStorage中token信息 */
export const getTokenInfoStorage = () => {
    return JSON.parse(localStorage.getItem('tokenInfo'))
};

/* todo 取localStorage中用户信息 */
export const getUserInfoStorage = () => {
    return JSON.parse(localStorage.getItem('userInfo'))
};

/* todo 取localStorage中系统公告 */
export const getSystemAnnounceStorage = () => {
    return JSON.parse(localStorage.getItem('announce'))
};

/* todo 取localStorage中消息列表 */
export const getUserMessageStorage = () => {
    return JSON.parse(localStorage.getItem('userMessage'))
};

/* 获取昨日日期 */
export const getNearlyYesterday = () => {
    const oneDayDate = 24 * 60 * 60 * 1000;
    const date = new Date() - oneDayDate;

    const year = new Date(date).getFullYear();
    const month = new Date(date).getMonth() + 1;
    const day = new Date(date).getDate();
    return year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day);
};
/* 获取近7日日期 */
export const getNearly7Days = () => {
    const oneDayDate = 24 * 60 * 60 * 1000;
    const date = new Date() - oneDayDate * 7;

    const year = new Date(date).getFullYear();
    const month = new Date(date).getMonth() + 1;
    const day = new Date(date).getDate();
    return year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day);
};
/* 获取近15日日期 */
export const getNearly15Days = () => {
    const oneDayDate = 24 * 60 * 60 * 1000;
    const date = new Date() - oneDayDate * 15;
    const year = new Date(date).getFullYear();
    const month = new Date(date).getMonth() + 1;
    const day = new Date(date).getDate();
    return year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day);
};
/* 获取近30日日期 */
export const getNearly30Days = () => {
    const oneDayDate = 24 * 60 * 60 * 1000;
    const date = new Date() - oneDayDate * 30;
    const year = new Date(date).getFullYear();
    const month = new Date(date).getMonth() + 1;
    const day = new Date(date).getDate();
    return year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day);
};
/* 获取近30日日期 */
export const getThisMonth = () => {
    // 创建一个表示当前日期的 Date 对象
    const currentDate = new Date();
    // 将日期设置为下个月的第一天
    currentDate.setMonth(currentDate.getMonth() + 1, 1);
    // 将日期减去一天，即为本月的最后一天
    currentDate.setDate(currentDate.getDate() - 1);
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth() + 1;
    const day = currentDate.getDate();
    return year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day);
};

/* todo 取localStorage中h5配置信息 */
export const getConfigStorage = () => {
    return JSON.parse(localStorage.getItem('config'))
};

/* todo 取localStorage中h5UUID配置信息 */
export const getH5UUIDStorage = () => {
    return JSON.parse(localStorage.getItem('h5UUID'))
};

/* todo 取localStorage中id */
export const getIDStorage = () => {
    return JSON.parse(localStorage.getItem('id'))
};

/* todo 取localStorage中渠道Code */
export const getChannelsCodeStorage = () => {
    return JSON.parse(localStorage.getItem('channels_code'))
};

/* todo 获取操作系统 */
export const getOS = () => {
    let u = navigator.userAgent, version = ''
    if (u.indexOf('Mac OS X') > -1) {
        // ios
        let regStr_saf = /OS [\d._]*/gi
        let verinfo = u.match(regStr_saf)
        // version = 'IOS' + (verinfo + '').replace(/[^0-9|_.]/ig, '').replace(/_/ig, '.')
        // version = 'ios'
        version = 'h5'
    } else if (u.indexOf('Android') > -1 ||
        u.indexOf('Linux') > -1) {
        // android
        // version = 'Android' + u.substr(u.indexOf('Android') + 8, u.indexOf(';', u.indexOf('Android')) - u.indexOf('Android') - 8)
        // version = 'android'
        version = 'h5'
    } else if (u.indexOf('BB10') > -1) {
        // 黑莓bb10系统
        // version = 'blackberry' + u.substr(u.indexOf('BB10') + 5, u.indexOf(';', u.indexOf('BB10')) - u.indexOf('BB10') - 5)
        // version = 'blackberry'
        version = 'h5'
    } else if (u.indexOf('IEMobile') > -1) {
        // windows phone
        // version = 'winphone' + u.substr(u.indexOf('IEMobile') + 9, u.indexOf(';', u.indexOf('IEMobile')) - u.indexOf('IEMobile') - 9)
        // version = 'winphone'
        version = 'h5'
    } else {
        /*let userAgent = navigator.userAgent.toLowerCase()
        if (userAgent.indexOf('windows nt 5.0') > -1) {
            version = 'Windows 2000'
        } else if (userAgent.indexOf('windows nt 5.1') > -1 || userAgent.indexOf('windows nt 5.2') > -1) {
            version = 'Windows XP'
        } else if (userAgent.indexOf('windows nt 6.0') > -1) {
            version = 'Windows Vista'
        } else if (userAgent.indexOf('windows nt 6.1') > -1 || userAgent.indexOf('windows 7') > -1) {
            version = 'Windows 7'
        } else if (userAgent.indexOf('windows nt 6.2') > -1 || userAgent.indexOf('windows 8') > -1) {
            version = 'Windows 8'
        } else if (userAgent.indexOf('windows nt 6.3') > -1) {
            version = 'Windows 8.1'
        } else if (userAgent.indexOf('windows nt 6.2') > -1 || userAgent.indexOf('windows nt 10.0') > -1) {
            version = 'Windows 10'
        } else {
            version = 'Unknown'
        }*/
        version = 'pc'
    }
    return version;
    // this.setState({
    //     os: version
    // })
}

// todo 毫秒转换具体时间
export const getDateFromMillisecond = (millisecond) => {
    const date = new Date(parseInt(millisecond));
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hour = date.getHours();
    const minute = date.getMinutes();
    const second = date.getSeconds();

    // return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second
    return year + '-' + month + '-' + day
}


// todo 秒转换具体时间
export const getDateFromSecond = (millisecond) => {
    const date = new Date(parseInt(millisecond) * 1000);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hour = date.getHours();
    const minute = date.getMinutes();
    const second = date.getSeconds();

    // return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second
    return year + '-' + month + '-' + day
}
